import Header from "./components/Header";
import MainContainer from "./components/MainContainer";

function App() {
  return (
    <div className="bg-gray-50 h-full md:h-screen relative">
      <Header />
      <MainContainer />
    </div>
  );
}

export default App;
